import {
  useGetUserQuery,
  useGetCredentialsQuery,
  useGetWalletQuery,
} from '../redux/api/user-api'
import { useSelector } from 'react-redux'

export const useGetUser = () => {
  const userId = localStorage.getItem('userId')

  const {
    data: user,
    isLoading: isLoadingUser,
    error: errorUser,
  } = useGetUserQuery(userId, {
    skip: !userId,
  })

  const {
    data: credentials,
    isLoading: isLoadingCredentials,
    error: errorCredentials,
  } = useGetCredentialsQuery(user?.usuarioid, {
    skip: !user?.usuarioid,
  })

  const {
    data: wallet,
    isLoading: isLoadingWallet,
    error: errorWallet,
  } = useGetWalletQuery(credentials?.id, {
    skip: !credentials?.id,
  })

  const {
    walletDirection: {
      polygonAddress,
      tronAddress,
      isLoading: isLoadingWalletDirection,
      error: errorWalletDirection,
    },
  } = useSelector((state) => state.wallets)

  return {
    userId,
    user,
    isLoadingUser,
    errorUser,
    credentials,
    isLoadingCredentials,
    errorCredentials,
    wallet,
    isLoadingWallet,
    errorWallet,
    polygonAddress,
    tronAddress,
    isLoadingWalletDirection,
    errorWalletDirection,
  }
}
